import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-container-colored-polygon',
  templateUrl: '../../_base/layout/layout-container.component.html',
  standalone: false,
})
export class LayoutContainerColoredPolygonComponent {
  public imageUrl: any = './assets/images/polygon.svg';

  public applyColoringToBg = true;
}
